"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function clamp(num, min, max) {
    return Math.max(min, Math.min(max, num));
}
exports.clamp = clamp;



//////////////////
// WEBPACK FOOTER
// ./~/@shopify/javascript-utilities/math.js
// module id = ./node_modules/@shopify/javascript-utilities/math.js
// module chunks = 0